import { useLocalization } from '@fluent/react';
import { useField } from 'formik';

import { convertPathToDotNotation } from './Formik';
import { convertPathToTranslatableKey } from '#/utils/l10n';

const Field: React.FC<FieldProps> = ({ children, name }) => {
  const { l10n } = useLocalization();
  const [, meta] = useField(name);
  const showError = meta.touched && !!meta.error;
  const errorMessage = convertPathToDotNotation(meta.error || '').replace(
    name,
    l10n.getString(convertPathToTranslatableKey(name)),
  );

  return (
    <div>
      <div>{children}</div>
      {showError && (
        <label>
          <span className="text-red-700">{errorMessage}</span>
        </label>
      )}
    </div>
  );
};
export type FieldProps = {
  children: React.ReactNode;
  name: string;
};

export default Field;
